import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

const navButtonStyle = {
  margin: "0 6px",
  color: "#FFD700",
  background: "rgba(20,30,30,0.22)",
  padding: "9px 18px",
  borderRadius: "20px",
  textDecoration: "none",
  fontWeight: "bold",
  fontSize: "1.08em",
  border: "1.5px solid #FFD700",
  transition: "all .18s",
};

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLinkClick = () => setMenuOpen(false);

  // optional: lock body scroll when menu is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [menuOpen]);

  return (
    <nav
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: 1000,
        padding: "13px 18px",
        background: "rgba(20,30,30,0.93)",
        color: "#FFD700",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: "1.5px solid #FFD700",
        boxShadow: "0 2px 10px rgba(0,0,0,0.13)",
        overflow: "visible",
      }}
    >
      {/* Left: Logo */}
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={logo}
          alt="MONKZI Logo"
          style={{
            width: "42px",
            height: "42px",
            borderRadius: "50%",
            marginRight: "12px",
          }}
        />
        <span
          style={{
            fontWeight: "bold",
            fontSize: "1.32em",
            letterSpacing: "2px",
            color: "#FFD700",
          }}
        >
          Monkilla
        </span>
      </div>

      {/* Center: Announcement (hidden on small screens) */}
      <div
        className="nav-annc"
        style={{
          flex: 1,
          textAlign: "center",
          padding: "0 16px",
        }}
      >
        <span
          style={{
            background: "#FFD700",
            color: "#141E1E",
            padding: "6px 14px",
            borderRadius: "18px",
            fontWeight: "bold",
            fontSize: "0.95em",
            whiteSpace: "nowrap",
            animation: "pulse 1.5s infinite",
            display: "inline-block",
          }}
        >
          🚨 MONKZI / USDT Pairing is Live! 🚀
        </span>
      </div>

      {/* Right: Desktop Navigation */}
      <div
        className="nav-links"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          paddingRight: "18px",
        }}
      >
        <Link to="/" style={navButtonStyle}>
          Home
        </Link>
        <Link to="/how-to-buy" style={navButtonStyle}>
          How to Buy
        </Link>
        <Link to="/About" style={navButtonStyle}>
          About Us
        </Link>
        <Link to="/vote" style={navButtonStyle}>
          Vote
        </Link>
        <Link to="/giveaway" style={navButtonStyle}>
          Giveaway
        </Link>
      <Link to="/blog" style={navButtonStyle}>Blog</Link>
      </div>

      {/* Hamburger button (mobile only) */}
      <button
        className={`hamburger ${menuOpen ? "is-open" : ""}`}
        aria-label="Toggle menu"
        aria-expanded={menuOpen}
        onClick={() => setMenuOpen((v) => !v)}
        style={{
          display: "none", // shown via media query
          background: "transparent",
          border: "none",
          cursor: "pointer",
          padding: 8,
          marginLeft: 8,
        }}
      >
        <span className="hb-bar" />
        <span className="hb-bar" />
        <span className="hb-bar" />
      </button>

      {/* Mobile Dropdown */}
      {menuOpen && (
        <div
          className="mobile-menu"
          style={{
            position: "fixed",
            top: 65,
            right: 16,
            background: "rgba(10, 20, 30, 0.98)",
            borderRadius: "20px",
            border: "1.5px solid #FFD700",
            boxShadow: "0 8px 32px rgba(0,0,0,0.35)",
            padding: "20px 10px",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            zIndex: 2000,
            minWidth: "170px",
            width: "65vw",
            maxWidth: "260px",
          }}
        >
          <Link to="/" style={navButtonStyle} onClick={handleLinkClick}>
            Home
          </Link>
          <Link to="/how-to-buy" style={navButtonStyle} onClick={handleLinkClick}>
            How to Buy
          </Link>
          <Link to="/About" style={navButtonStyle} onClick={handleLinkClick}>
            About Us
          </Link>
          <Link to="/vote" style={navButtonStyle} onClick={handleLinkClick}>
            Vote
          </Link>
          <Link to="/giveaway" style={navButtonStyle} onClick={handleLinkClick}>
            Giveaway
          </Link>
        <Link to="/blog" style={navButtonStyle}>Blog</Link>
        </div>
      )}

      {/* Responsive CSS + Pulse + Hamburger animation */}
      <style>{`
        /* Hide announcement on narrow screens to free space */
        @media (max-width: 820px) {
          .nav-annc { display: none !important; }
          .nav-links { display: none !important; }
          .hamburger { display: inline-flex !important; flex-direction: column; gap: 5px; }
        }
        @media (min-width: 821px) {
          .mobile-menu { display: none !important; }
        }

        /* Pulse keyframes */
        @keyframes pulse {
          0% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.05); opacity: 0.9; }
          100% { transform: scale(1); opacity: 1; }
        }

        /* Hamburger bars */
        .hb-bar {
          width: 26px;
          height: 3px;
          background: #FFD700;
          border-radius: 2px;
          transition: transform .25s ease, opacity .2s ease, width .2s ease;
          display: block;
        }
        .hamburger.is-open .hb-bar:nth-child(1) {
          transform: translateY(6px) rotate(45deg);
        }
        .hamburger.is-open .hb-bar:nth-child(2) {
          opacity: 0;
          width: 0;
        }
        .hamburger.is-open .hb-bar:nth-child(3) {
          transform: translateY(-6px) rotate(-45deg);
        }
      `}</style>
    </nav>
  );
};

export default Navbar;
